import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { TimeOffRequestDay } from '@models/time-off-v3/time-off-request-day.model';
import { makeTwoDecimalPointsNumberMask } from '@app/functions';
import { formatLocalizedNumber, Locale, parseLocalizedNumber } from '@app/types/translatable.type';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-request-day-form',
    templateUrl: './request-day.template.html',
    styleUrls: ['./request-day.style.scss'],
})
export class RequestDayForm extends BaseForm {
    @ViewChild('timeOffRequestDayInput') timeOffRequestDayInput;
    @Input() timeOffRequestDay: TimeOffRequestDay;
    @Input() maxAmount: number;
    @Output() update: EventEmitter<TimeOffRequestDay> = new EventEmitter<TimeOffRequestDay>();
    twoDecimalPointsNumberMask = makeTwoDecimalPointsNumberMask();

    constructor(private translateService: TranslateService) {
        super();
    }

    /**
     * Get a localized display value for time off request day
     * @param dayAmount - The raw time off request value for a day to be formatted
     * @returns The formatted time off value based on current locale
     */
    getFormattedRequestDayAmount(dayAmount: number): string | undefined {
        return formatLocalizedNumber(dayAmount, {
            locale: this.translateService.currentLang as Locale,
            decimalPlaces: 2,
        });
    }

    /**
     * Set a localized value for time off request value for a day after parsing the input
     * @param value - The localized string representation of the time off request value
     */
    setFormattedRequestDayAmount(dayAmount: string): void {
        const parsedValue = parseLocalizedNumber(dayAmount, this.translateService.currentLang as Locale);
        this.submit();

        if (!this.valid) {
            return;
        }

        this.timeOffRequestDay.amount = parsedValue;
        this.update.emit(this.timeOffRequestDay);
    }
}
